export default "__VITE_ASSET__Yg_OC2BW__"